import { render, staticRenderFns } from "./WarehouseUserForm.vue?vue&type=template&id=7bfb135b&"
import script from "./WarehouseUserForm.vue?vue&type=script&lang=js&"
export * from "./WarehouseUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports